import { render, staticRenderFns } from "./Moeda.vue?vue&type=template&id=749f2028"
import script from "./Moeda.vue?vue&type=script&lang=js"
export * from "./Moeda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports